import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const QuizSkeleton = () => {
  return (
    <>
      {/* Progress bar skeleton */}
      <div className="d-flex justify-content-between mb-4 mt-4">
        {[...Array(5)].map((_, i) => (
          <Skeleton
            key={i}
            height={4}
            width="15%"
            baseColor="#ffffff30"
            highlightColor="#ffffff50"
          />
        ))}
      </div>

      {/* Question number skeleton */}
      <div className="text-center mb-3">
        <Skeleton
          width={200}
          height={40}
          borderRadius={8}
          baseColor="#ffffff30"
          highlightColor="#ffffff50"
        />
      </div>

      {/* Question text skeleton */}
      <div className="text-center my-4">
        <Skeleton
          count={2}
          height={24}
          baseColor="#ffffff30"
          highlightColor="#ffffff50"
        />
      </div>

      {/* Options skeleton */}
      <div className="options-container">
        {[...Array(4)].map((_, i) => (
          <Skeleton
            key={i}
            height={50}
            borderRadius={30}
            baseColor="#ffffff30"
            highlightColor="#ffffff50"
          />
        ))}
      </div>

      {/* Button skeleton */}
      <div className="d-flex justify-content-between mt-4">
        <Skeleton
          width={120}
          height={45}
          borderRadius={50}
          baseColor="#ffffff30"
          highlightColor="#ffffff50"
        />
        <Skeleton
          width={140}
          height={45}
          borderRadius={50}
          baseColor="#ffffff30"
          highlightColor="#ffffff50"
        />
      </div>
    </>
  );
};

export default QuizSkeleton;
